/* cubed · the product gallery, the store's own file (the shared sb-motion.js keeps the variant picker,
   the price and the colour groups; this file only changes how the views move).
   - Arrows at the middle of the picture, shown on hover, step to the previous or next view.
   - Choosing a view several places away travels through the views between it, a fast slide like
     Kettle & Chalk's gallery, never a jump: one step 260ms, each extra step +110ms.
   - A swipe on a touch screen steps too. The listeners are passive: the page's scroll is never touched.
   - A colour change dyes the view on screen into the SAME view in the new colour (VANTA's product
     page), not always the first one.
   Every move is a CSS transition written after the resting style is computed: no requestAnimationFrame
   (doctrine §4). With reduced motion the view changes at once. */
(function () {
  "use strict";
  var SB = window.SB || (window.SB = {});
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  console.log("⚙️ [Function Started]: cubed-gallery", reduce ? "(reduced motion)" : "");

  // A phone shows eight views at most, two rows of four under the picture (the owner, 2026-10-20;
  // cubed-phone.css hides the rest): a swipe walks those eight. A computer keeps every view.
  var phone = window.matchMedia("(max-width: 749px)");
  var PHONE_VIEWS = 8;
  function views(thumbs) {
    var list = Array.prototype.slice.call(thumbs.querySelectorAll("[data-sb-view]"));
    return phone.matches ? list.slice(0, PHONE_VIEWS) : list;
  }
  function current(list) {
    for (var i = 0; i < list.length; i++) if (list[i].getAttribute("aria-pressed") === "true") return i;
    return 0;
  }
  function press(list, i) { list.forEach(function (b, k) { b.setAttribute("aria-pressed", k === i ? "true" : "false"); }); }
  function load(src) {
    return new Promise(function (resolve) {
      var im = new Image();
      im.src = src;
      if (im.complete) { resolve(); return; }
      im.onload = function () { resolve(); };
      im.onerror = function (err) { console.error("🛑 [Error]: gallery picture failed to load", src, err); resolve(); };
    });
  }

  function mount(gallery) {
    if (gallery.__cubed) return;
    var stage = gallery.querySelector("[data-sb-crossfade]");
    var thumbs = gallery.querySelector("[data-sb-thumbs]");
    var base = stage && stage.querySelector("[data-sb-stage-base]");
    if (!stage || !thumbs || !base) return;
    gallery.__cubed = true;
    var busy = false, queued = null;

    // ---------------------------------------------------------------- the arrows
    ["prev", "next"].forEach(function (dir) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "cubed-step cubed-step--" + dir;
      b.setAttribute("aria-label", dir === "prev" ? "Previous view" : "Next view");
      b.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="' +
        (dir === "prev" ? "M15 5l-7 7 7 7" : "M9 5l7 7-7 7") +
        '" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      b.addEventListener("click", function () {
        var list = views(thumbs);
        if (list.length < 2) return;
        var from = current(list);
        var step = dir === "next" ? 1 : -1;
        var to = (from + step + list.length) % list.length;
        console.log("👆 [Trigger]: gallery arrow", dir, from + 1, "→", to + 1);
        go(from, to, step, true);
      });
      stage.appendChild(b);
    });
    function sync() { stage.toggleAttribute("data-cubed-single", views(thumbs).length < 2); }
    sync();
    new MutationObserver(sync).observe(thumbs, { childList: true });

    // ---------------------------------------------------------------- the thumbnails
    // Capture on the list, then stop: the shared crossfade (a bubble listener on the same list) never runs.
    thumbs.addEventListener("click", function (e) {
      var b = e.target.closest("[data-sb-view]");
      if (!b) return;
      e.stopPropagation();
      var list = views(thumbs);
      var from = current(list), to = list.indexOf(b);
      console.log("👆 [Trigger]: view", to + 1, "chosen from view", from + 1);
      go(from, to, to > from ? 1 : -1, false);
    }, true);

    // ---------------------------------------------------------------- a swipe
    var sx = 0, sy = 0, tracking = false;
    stage.addEventListener("touchstart", function (e) {
      if (e.touches.length !== 1) return;
      tracking = true; sx = e.touches[0].clientX; sy = e.touches[0].clientY;
    }, { passive: true });
    stage.addEventListener("touchend", function (e) {
      if (!tracking) return;
      tracking = false;
      var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.3) return;
      var list = views(thumbs);
      if (list.length < 2) return;
      var step = dx < 0 ? 1 : -1, from = current(list);
      console.log("👆 [Trigger]: gallery swipe", step > 0 ? "next" : "previous");
      go(from, (from + step + list.length) % list.length, step, true);
    }, { passive: true });

    // ---------------------------------------------------------------- the move
    // wrap: an arrow or a swipe past either end goes one step in its own direction.
    function go(from, to, dir, wrap) {
      if (from === to) return;
      if (busy || stage.querySelector(".sb-dye.on")) { queued = { to: to }; console.log("📦 [State Update]: gallery busy, view", to + 1, "queued"); return; }
      var list = views(thumbs);
      var path = [];
      if (wrap) path = [from, to];
      else for (var i = from; i !== to; i += dir) path.push(i);
      if (!wrap) path.push(to);
      var srcs = path.map(function (k) { return list[k].getAttribute("data-sb-view"); });
      press(list, to);
      if (reduce) {
        base.removeAttribute("srcset");
        base.src = srcs[srcs.length - 1];
        console.log("✅ [gallery]: view", to + 1, "(reduced motion: at once)");
        return;
      }
      busy = true;
      var t0 = performance.now();
      Promise.all(srcs.map(load)).then(function () {
        var steps = srcs.length - 1;
        var order = dir > 0 ? srcs : srcs.slice().reverse();
        var strip = document.createElement("div");
        strip.className = "cubed-strip";
        strip.setAttribute("aria-hidden", "true");
        order.forEach(function (s) {
          var im = document.createElement("img");
          im.className = "cubed-strip__img";
          im.alt = "";
          im.src = s;
          strip.appendChild(im);
        });
        var startX = dir > 0 ? 0 : -steps * 100;
        var endX = dir > 0 ? -steps * 100 : 0;
        var ms = 260 + 110 * (steps - 1);
        strip.style.transform = "translate3d(" + startX + "%,0,0)";
        stage.appendChild(strip);
        base.style.visibility = "hidden";
        void strip.offsetWidth; // the resting style is computed: the next line transitions by itself
        strip.style.transition = "transform " + ms + "ms cubic-bezier(.65, .05, .36, 1)";
        strip.style.transform = "translate3d(" + endX + "%,0,0)";
        console.log("🚀 [gallery]: sliding through", steps, "step(s) in", ms + "ms");
        setTimeout(function () {
          base.removeAttribute("srcset");
          base.src = srcs[srcs.length - 1];
          var finish = function () {
            base.style.visibility = "";
            strip.remove();
            busy = false;
            console.log("✅ [gallery]: at rest on view", to + 1, Math.round(performance.now() - t0) + "ms after the input");
            if (queued) { var q = queued; queued = null; var l = views(thumbs); go(current(l), q.to, q.to > current(l) ? 1 : -1, false); }
          };
          if (base.decode) base.decode().then(finish, function (err) { console.error("🛑 [Error]: gallery decode failed", err); finish(); });
          else finish();
        }, ms + 20);
      });
    }
  }

  // ---------------------------------------------------------------- the dye keeps the view
  // sb-motion.js asks to dye to the new colour's FIRST photo, then repaints the thumbnails for that
  // colour. Wait for the repaint, find the view that was on screen in the new colour, dye to that.
  if (SB.dye && !SB.__cubedDye) {
    var dye = SB.dye;
    SB.__cubedDye = true;
    SB.dye = function (stage, src, alt) {
      var gallery = stage.closest("[data-sb-gallery]");
      var thumbs = gallery && gallery.querySelector("[data-sb-thumbs]");
      var keep = thumbs ? current(views(thumbs)) : 0;
      setTimeout(function () {
        var list = thumbs ? views(thumbs) : [];
        var i = Math.min(keep, list.length - 1);
        if (i >= 0 && list[i]) {
          press(list, i);
          src = list[i].getAttribute("data-sb-view");
          alt = undefined;
        }
        console.log("📦 [State Update]: the dye keeps view", i + 1);
        dye(stage, src, alt);
      }, 0);
    };
  }

  // ---------------------------------------------------------------- warm the next dye
  // sb-motion.js warms each colour's FIRST photo; the dye now goes to the view on screen, so warm that
  // view of a colour as soon as the pointer or the focus reaches its swatch, before the click.
  function warmColours(root) {
    var dataEl = root.querySelector("[data-sb-product-json]");
    var thumbs = root.querySelector("[data-sb-thumbs]");
    if (!dataEl || !thumbs || root.__cubedWarm) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (err) { console.error("🛑 [Error]: product JSON unreadable", err); return; }
    if (data.colorIndex < 0) return;
    root.__cubedWarm = true;
    var starts = data.variants.map(function (v) { return v.mediaPosition; }).filter(Boolean).sort(function (a, b) { return a - b; });
    var warmed = {};
    function viewOf(colour, index) {
      if (data.views) {
        var pos = data.views[colour] || [];
        var p = pos[Math.min(index, pos.length - 1)];
        return p ? data.media.find(function (m) { return m.position === p; }) || null : null;
      }
      var v = data.variants.find(function (x) { return x.options[data.colorIndex] === colour && x.mediaPosition; });
      if (!v) return null;
      var end = Infinity;
      starts.forEach(function (s) { if (s > v.mediaPosition && s < end) end = s; });
      var list = data.media.filter(function (m) { return m.position >= v.mediaPosition && m.position < end; });
      return list[Math.min(index, list.length - 1)] || null;
    }
    function warm(e) {
      var input = e.target.closest("label") ? e.target.closest("label").querySelector("input") : e.target.closest("input");
      if (!input || !input.closest(".sb-option--color")) return;
      var m = viewOf(input.value, current(views(thumbs)));
      if (!m || warmed[m.src]) return;
      warmed[m.src] = true;
      var im = new Image();
      im.src = m.src;
      console.log("🚀 [Async Start]: warming", input.value, "for the dye");
    }
    root.addEventListener("pointerover", warm, { passive: true });
    root.addEventListener("focusin", warm);
  }

  function boot(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll("[data-sb-product]"), warmColours);
    Array.prototype.forEach.call((root || document).querySelectorAll("[data-sb-gallery]"), mount);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { boot(); });
  else boot();
  document.addEventListener("shopify:section:load", function (e) {
    console.log("👆 [Trigger]: section reloaded in the editor");
    boot(e.target);
  });
})();
